import { RefObject, MouseEvent } from 'react'

export const isClickOutsideRef = <T extends HTMLElement>(
  contentRef: RefObject<T | null>,
  e: MouseEvent<T>,
): boolean =>
  !(
    contentRef.current &&
    e.target instanceof Node &&
    contentRef.current.contains(e.target)
  )
